/** ABP tenant role seeded for users allowed to preview/send alerts. */
export const ALERT_SENDER_ROLE = "alertsender";

/** Legacy BottomBar parity — UI gate before API enforcement. */
export function hasAlertSenderRole(roleNames: readonly string[] | null | undefined): boolean {
  if (!roleNames?.length) return false;
  return roleNames.some((r) => r.toLowerCase() === ALERT_SENDER_ROLE);
}
